// extracted by mini-css-extract-plugin
module.exports = {"setting":"setting___1eD4Q"};